import { BASIC_POLL_VOTE_TYPES, resolveBasicPollVoteType } from "./constants";
import { coerceDate } from "../time";

// A write-in "Other" response is itself a selectable slot, so it counts toward
// maxSelections (the voting card enforces the same cap at submit).
export function resolveSelectableCount({ optionCount = 0, allowWriteIn = false } = {}) {
  return Math.max(0, Number.isFinite(optionCount) ? optionCount : 0) + (allowWriteIn ? 1 : 0);
}

// Correct maxSelections rule:
//   - only applies to MULTIPLE_CHOICE with allowMultiple on (a cap of 1 means
//     single-choice, i.e. turn allowMultiple off — not "allow multiple");
//   - no finite max ⇒ unbounded (== selectableCount), always valid;
//   - otherwise require an integer 2 ≤ maxSelections ≤ selectableCount.
//
// Shared by CreateGroupPollModal and EmbeddedPollEditorModal so the two authoring
// surfaces can't drift.
export function validateMaxSelections({
  voteType,
  allowMultiple = false,
  allowWriteIn = false,
  optionCount = 0,
  maxSelections,
} = {}) {
  const resolvedVoteType = resolveBasicPollVoteType(voteType);
  if (resolvedVoteType !== BASIC_POLL_VOTE_TYPES.MULTIPLE_CHOICE) {
    return { valid: true, message: null };
  }
  if (!allowMultiple) {
    return { valid: true, message: null };
  }
  if (maxSelections === null || maxSelections === undefined || maxSelections === "") {
    return { valid: true, message: null };
  }

  const selectableCount = resolveSelectableCount({ optionCount, allowWriteIn });
  const parsed = Number(maxSelections);
  const writeInSuffix = allowWriteIn ? " plus write-in" : "";

  if (!Number.isFinite(parsed) || !Number.isInteger(parsed)) {
    return {
      valid: false,
      message: `Max selections must be a whole number from 2 to ${selectableCount}.`,
    };
  }
  if (parsed < 2) {
    return {
      valid: false,
      message: "Max selections must be at least 2 (use single-choice for one selection).",
    };
  }
  if (parsed > selectableCount) {
    return {
      valid: false,
      message: `Max selections can't be more than ${selectableCount} (the number of options${writeInSuffix}).`,
    };
  }
  return { valid: true, message: null };
}

export function isDeadlineInPast(deadlineAt) {
  const date = coerceDate(deadlineAt);
  if (!date) return false;
  return date.getTime() <= Date.now();
}
